import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { EventSource } from '@/shared/constants/event';
import { logCommonView } from '@/lib/service';
import './index.less';

const GetInTouch = ({ linkTo = `existing-brands/signup` }: { linkTo?: string }) => {
  const [email, setEmail] = useState<string>('');
  const router = useRouter();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e?.target?.value);
  };

  const handleKeyInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      router.push(`${linkTo}?email=${encodeURI(email)}`);
    }
  };

  const handleClick = () => {
    logCommonView(EventSource.EXISTING_BRANDS_GET_IN_TOUCH_FORM, email);
  };

  return (
    <div className="get-in-touch">
      <input className="input" placeholder="What's your email?" onChange={handleChange} onKeyDown={handleKeyInput} />
      <Link href={email ? `${linkTo}?email=${encodeURI(email)}` : linkTo} onClick={handleClick}>
        <button className="button">
          <Image width={12} height={12} src="/images/phone.svg" alt="phone" />
          <p>Get in touch</p>
        </button>
      </Link>
    </div>
  );
};

export default GetInTouch;
